import { render, staticRenderFns } from "./OccupationalSafetyPostDialog.vue?vue&type=template&id=3de651b7&scoped=true&"
import script from "./OccupationalSafetyPostDialog.vue?vue&type=script&lang=js&"
export * from "./OccupationalSafetyPostDialog.vue?vue&type=script&lang=js&"
import style0 from "./OccupationalSafetyPostDialog.vue?vue&type=style&index=0&id=3de651b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de651b7",
  null
  
)

export default component.exports